import React from 'react';
import SharedList from '../../../shared/list';

interface Props {
    getRoms: () => unknown;

    // FIXME: I haven't a clue what this is.
    list: any;
}

const RomList = (props: Props) => {
    return <>
        <SharedList
            notFoundMessage={<p>No ROMs found for this company</p>}
            getList={props.getRoms}
            list={props.list}
            idKey="romId"
        />
    </>;
};

export default RomList;
